import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";

import { ApiService } from "src/app/api.service";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { GitVersionService } from "src/app/gitversion.service";
declare const BrandVars: any;

@Component({
	selector: "app-hamburger-menu",
	templateUrl: "./hamburger-menu.component.html",
	styleUrls: ["./hamburger-menu.component.scss"]
})
export class HamburgerMenuComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];

	public brand = BrandVars;

	public menuShow = false;
	public clientVersion = "";
	public serverVersion = "";

	constructor(public router: Router, public api: ApiService, public git: GitVersionService, private fleettracker: FleetTrackerService) { }

	ngOnInit() {
		this.subscriptions.push(this.git.Client.subscribe(version => {
			this.clientVersion = version;
		}));
		this.subscriptions.push(this.git.Server.subscribe(version => {
			this.serverVersion = version;
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	ToggleMenu() {
		this.menuShow = !this.menuShow;
	}

	Logout() {
		this.api.Logout();
		this.fleettracker.Clear();
		this.router.navigate(["login"]);
	}

}
